import React from 'react';
import { connect } from 'react-redux';
import "./VideoTagV2.css";
import { injectIntl } from 'react-intl'
import { unsetIsVideoTagActive } from '../../../actions/CommentAction'
import {Icon, Tooltip} from "antd";
import VideoIconDart from "../../../assets/icons/video_dart.svg";

class VideoTagV2 extends React.Component {
    render() {
        const {
            versionNumber,
            unsetIsVideoTagActive,
            videoTime,
            intl
        } = this.props;
        return (
            <React.Fragment>
                <div className='video-tag-wrapper' >
                    <p>{intl.formatMessage({ id: "tagging_on_page" })} &nbsp; </p>
                    <div className='video-tag-text-indicator'>
                        <img src={VideoIconDart} alt="video" className='video-tag-icon' />
                        <p>{`${videoTime} v.${versionNumber}`}</p>
                    </div>
                    <p>&nbsp;&nbsp;</p>
                    <Tooltip placement='top' title={intl.formatMessage({ id: "delete_pdf_tag" })}>
                        <p className='cursor-pointer' onClick={unsetIsVideoTagActive}><Icon type="close-circle" /></p>
                    </Tooltip>

                </div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    isAudioTagActive: state.comments.isAudioTagActive,
    videoTime: state.comments.videoTime,
    versionNumber: state.comments.itemSelected.document.versionNumber

})

const mapDispatchToProps = {
    unsetIsVideoTagActive
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(VideoTagV2))
